import { apiGet } from '@/services/api';

const ADMIN = '/api/v1/admin/nomenclatures';

/**
 * The administered nomenclatures (FR-042), read by several features: "Configurare sistem" lists and
 * edits them, the news modal suggests CONTENT_CATEGORII, the training screens TRAINING_TEMATICI,
 * and the public pages read theirs anonymously. Editing endpoints only the configuration screen
 * uses stay in that feature's own api module.
 *
 * Item types are the caller's: the admin items carry `active`, the public ones `metadata`, and
 * each screen declares the fields it reads.
 */
export const nomenclatureApi = {
  list: <T>() => apiGet<T[]>(ADMIN),
  items: <T>(nomenclatureId: string) => apiGet<T[]>(`${ADMIN}/${nomenclatureId}/items`),
  /**
   * The items of the nomenclature with this code. The admin endpoint takes an id, so the code is
   * looked up first; an unknown code yields no items rather than an error — a missing picker is a
   * smaller problem than a screen that will not open.
   */
  async itemsByCode<T>(code: string): Promise<T[]> {
    const nomenclatures = await apiGet<{ id: string; code: string }[]>(ADMIN);
    const domain = nomenclatures.find((n) => n.code === code);
    return domain ? apiGet<T[]>(`${ADMIN}/${domain.id}/items`) : [];
  },
  /** Served by the public endpoint, so an anonymous page can read it too. */
  publicItems: <T>(code: string) => apiGet<T[]>(`/api/v1/public/nomenclatures/${code}/items`),
};
